import { colors } from "common/const/colors";
import { I18N_KEYS } from "common/i18n/keys";

export const PaymentChannel = Object.freeze({
  ALL: I18N_KEYS.common.all,
  APP: I18N_KEYS.enum.PaymentChannel.APP,
  WEB: I18N_KEYS.enum.PaymentChannel.WEB,
  ON_SITE: I18N_KEYS.enum.PaymentChannel.ON_SITE,
});

export const PaymentCategory = Object.freeze({
  ALL: I18N_KEYS.common.all,
  FNB: I18N_KEYS.enum.PaymentCategory.FNB,
  OTHER: I18N_KEYS.enum.PaymentCategory.OTHER,
  RESERVATION: I18N_KEYS.enum.PaymentCategory.RESERVATION,
});

export const PaymentMethod = Object.freeze({
  ALL: I18N_KEYS.common.all,
  CARD: I18N_KEYS.enum.PaymentMethod.CARD,
  CASH: I18N_KEYS.enum.PaymentMethod.CASH,
  COMPLEX: I18N_KEYS.enum.PaymentMethod.COMPLEX,
  // ONLINE: "Online",
  // TRANSFER: "Transfer",
});

export const PaymentStatus = Object.freeze({
  APPROVED: {
    text: I18N_KEYS.enum.PaymentStatus.APPROVED,
    color: colors.Green,
  },
  CANCELLED: {
    text: I18N_KEYS.enum.PaymentStatus.CANCELLED,
    color: colors.Red,
  },
  REFUND: {
    text: I18N_KEYS.enum.PaymentStatus.REFUND,
    color: colors.LightNavy,
  },
});

export const DiscountType = Object.freeze({
  COUPON: I18N_KEYS.enum.DiscountType.COUPON,
  MEMBERSHIP: I18N_KEYS.enum.DiscountType.MEMBERSHIP,
});

export const DiscountFilterType = Object.freeze({
  ALL: I18N_KEYS.common.all,
  APPLIED: I18N_KEYS.enum.DiscountFilterType.APPLIED,
  NONE: I18N_KEYS.enum.DiscountFilterType.NONE,
});
